export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const CREATE_CHANGE = 'CREATE_CHANGE'
export const GET_CHANGE_LIST = 'GET_CHANGE_LIST'
export const GET_CHANGE_USER_LIST = 'GET_CHANGE_USER_LIST'
export const GET_CHANGE_TEMPLATES = 'GET_CHANGE_TEMPLATES'
